import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { TableCell, MenuItem } from '@material-ui/core';
import classNames from 'classnames';
import _ from 'lodash';

import './MainMarkets.scss';
import SportContext from '../Context/Sport.context';
import DropDown from '../../DropDown/DropDown';
import Icon from '../../Icon/Icon';

interface MainMarketsProps {
  index: number,
  selectedMarket: {
    headers: { outcomeName: string; }[],
    vars: number,
    marketTypeName: string,
    marketTypeCode: number
  },
  onChange: (index: number, marketTypeCode: number) => (event) => void, // eslint-disable-line
}

function MainMarkets({ selectedMarket, onChange, index }: MainMarketsProps) {
  const {
    selectedMainMarkets,
    sport: { mainMarkets }
  } = useContext(SportContext);

  const showDropDown = selectedMainMarkets.length < Object.keys(mainMarkets).length;

  return (
    <>
      <TableCell
        className="main-markets__tournament-market-dropdown-container"
        align="center"
        colSpan={ Object.keys(selectedMarket.headers).length + (selectedMarket.vars !== 0 ? 1 : 0) }
      >
        <DropDown
          value={ selectedMarket.marketTypeName }
          className={
            classNames({
              'dropdown--blue': true,
              'main-markets__cursor': !showDropDown
            })
          }
          IconComponent={ showDropDown ? <Icon icon="arrow" /> : <div /> }
          popperClass="popper--dark"
        >
          {
            showDropDown ?
              _.map(mainMarkets, (m, msi) => {
                const marketIndex = _.findIndex(selectedMainMarkets, { marketTypeCode: m.marketTypeCode });
                return (
                  <MenuItem
                    key={ msi }
                    className={
                      classNames({
                        item: true,
                        'item--disabled': marketIndex !== -1
                      })
                    }
                    value={ m.marketTypeCode }
                    disabled={ marketIndex !== -1 }
                    onClick={ onChange(index, selectedMarket.marketTypeCode) }
                  >
                    { m.marketTypeName }
                  </MenuItem>);
              })
              :
              <div />
          }
        </DropDown>
      </TableCell>

      {
        Object.keys(selectedMarket.headers).length <= 3 && (
          <TableCell align="center" className="sport-table__divider"></TableCell>
        )
      }
    </>
  );
}

MainMarkets.propTypes = {
  index: PropTypes.number,
  selectedMarket: PropTypes.object,
  onChange: PropTypes.func
};

export default React.memo(MainMarkets);
